import styled from "styled-components";
import {
  Space,
  Button as AntButton,
} from "antd";
import {
  IMG_WHEEL_BG,
  NumberAvatar,
  SpinContainerBg,
  RefreshOutlined,
} from "@assets";

export const RootContainer = styled.div`
  position: relative;
  height: 100vh;
  overflow-y: auto;
`;
export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const DailyWinnerListContainer = styled.div`
  margin: 291px 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 400px) {
    margin: 298px 0 0 0;
  }
`;

export const TitleWrapper = styled.div`
position: fixed;
width: 100%;
max-width: 480px;
padding-bottom: 8px;
text-align: center;
background: #fff;
z-index: 10;
`;

export const SmallRedBox = styled.div`
  width: 100%;
  height: 3px;
  background: #C21C05;
`;

export const Title = styled.div`
  text-align: center;
  border-radius: 0px 0px 16px 16px;
  background: #C21C05;
  padding: 8px 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  color: #EFEFEF;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const PlayerListContainer = styled.div`
  width: 100%;
  margin: 50px 0 0 0;
  overflow: auto;
`

export const PlayerBox = styled.div`
  background: #F7F7F7;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 1px;
`

export const NumberContainer = styled.div`
  width: 60px;
  height: 60px;
  position: relative;
`
export const NumberBackgroundAvatar = styled(NumberAvatar)`
`
export const Number = styled.p`
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: absolute;
  top: 23px;
  left: 24px;
  color: #101415;
`

export const DataContainer = styled.div`
  flex-grow: 1;
  gap: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NameAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PlayerName = styled.p`
  flex-grow: 1;
  color: #101415;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const Amount = styled.p`
  color: #C21C05;
  text-align: right;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const PhoneNumberAndLuckestContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PhoneNumber = styled.p`
  flex-grow: 1;
  color:  #808080;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const RulesAndHistoryContainer = styled.div`
  z-index: 30;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 8px;
  width: calc(100% - 32px);
  max-width: 448px;
  padding: 12px 16px !important;
  background-color: #fff;

 .ant-btn{
  flex: 1;
  height: 52px;
 }
 .ant-btn-primary:not(.ant-btn-dangerous){
    width: calc(50% - 20px) !important;
  }
`

export const RulesButton = styled(AntButton)`
  border-radius: 34px;
  background: #DEDEDE;

  color: #101415;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  height: 52px;
`

export const HistoryButton = styled(AntButton)`
  border-radius: 34px;
  background-color: #C21C05;

  color:  #F7F7F7 !important;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 50%;
  height: 52px;
`

export const Bottom = styled(Space)`
  padding-top: 305px;
  padding-bottom: 16px;
  z-index: 99;
  background-color: ${(props) => props.theme.backgroundColor};
  position: fixed;
  width: 100%;
  max-width: 480px;
  gap: 16px !important;
  justify-content: center;

  .ant-space-item {
    flex: 1;

    :nth-child(1) {
      text-align: right;
      padding-inline-start: 16px;
    }

    :nth-child(2) {
      text-align: left;
      padding-inline-end: 16px;
    }
  }

  .ant-btn {
    width: 100%;
    background-color: #71207c !important;
  }

  @media screen and (max-width: 400px) {
    padding-top: 285px;
  }
`;

export const TopBgImage = styled.img.attrs({
  alt: "bg-img",
  src: SpinContainerBg,
})`
  position: fixed;
  top: 69px;
  width: 100%;
  max-width: 480px;
  height: 293px;
  z-index: 500;

  @media screen and (min-width: 400px) {
    height: 300px;
  }
`;

export const SpinnerBox = styled.div`
  width: 100%;
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const WheelContainer = styled.div`
  position: fixed;
  width: 100%;
  max-width: 480px;
  height: 293px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 220px;
    height: 220px;
  }

  img:not(#badge-img) {
    display: none !important;
  }

  @media screen and (min-width: 400px) {
    height: 300px;
  }

  @media screen and (max-width: 350px) {
    > div {
      width: 190px;
      height: 190px;
    }
  }

`;

export const OuterBadge = styled.img.attrs({
  alt: "badge",
  id: "badge-img",
  src: IMG_WHEEL_BG,
})`
  position: absolute;
  width: 245px;
  height: 245px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;

  @media screen and (max-width: 350px) {
    width: 210px;
    height: 210px;
  }
`;

export const Container = styled.div`
  position: relative;
  z-index: 999;
  text-align: center;
  margin-top: 350px;

  .ant-btn {
    height: 52px;
    margin-top: 24px;
    max-width: 170px;
  }
`;

export const Text = styled.div`
  padding-bottom: 10px;
  color: #101415;
  font-size: 18px;
`;

export const SpinWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  position: relative;
`;

export const EmptyText = styled.div`
height: calc(100vh - 490px);
display: flex;
align-items: center;
justify-content: center;

font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;